<section class="mt-section">
  <div v-if="status === 'in_work'" class="mt-group">
    <fou-expand
      rows="1"
      :id="$vId(this, 'expand')"
      :trigger-title="$t('pages.submissions.components.upload.uploader.description.read_more')"
      :trigger-title-open="$t('pages.submissions.components.upload.uploader.description.read_less')">
      <div>
        <p v-html="uploaderDescription"></p>
        <p v-html="$t('pages.submissions.components.upload.uploader.description.otf_ttf')"></p>
      </div>
    </fou-expand>
  </div>
  <div v-if="status === 'live'" class="mt-group">
    <fou-expand rows="6" :id="$vId(this, 'expand')"
      :trigger-title="$t('pages.submissions.components.upload.uploader.description.read_more')"
      :trigger-title-open="$t('pages.submissions.components.upload.uploader.description.read_less')">
      <div :class="$style.padding_bottom">
        <p class="mt-line" v-html="$sanitize($t('pages.submissions.components.upload.uploader.description.drandrop_live_1'))"></p>
        <ul :class="['mt-line', 'mt-list', 'mt-list--indent' , $style.padding_bottom]">
          <li class="mt-list-item" v-html="$t('pages.submissions.components.upload.uploader.description.criteria.limit')">
          </li>
          <li class="mt-list-item" v-html="$t('pages.submissions.components.upload.uploader.description.criteria.nozip')">
          </li>
          <li class="mt-list-item"
            v-html="$t('pages.submissions.components.upload.uploader.description.criteria.otf_ttf')"></li>
        </ul>
        <p class="mt-line" v-html="$t('pages.submissions.components.upload.uploader.description.otf_ttf')"></p>
      </div>
    </fou-expand>
  </div>
</section>